import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import pdfService from './pdfService';

const pdfServiceAdvanced = {
  generatePurchaseOrderPDF: async (purchaseOrder) => {
    // Create a temporary div to render the PDF content
    const element = document.createElement('div');
    element.style.position = 'absolute';
    element.style.left = '-9999px';
    element.style.top = '0';
    element.style.width = '210mm';
    element.style.padding = '15mm';
    element.style.fontFamily = 'Arial, sans-serif';
    element.style.backgroundColor = 'white';
    element.style.color = '#333';
    
    // Safely calculate amounts with proper fallbacks
    const calculateSafeAmount = (value, fallback = 0) => {
      const numValue = parseFloat(value);
      return isNaN(numValue) ? fallback : numValue;
    };

    // Calculate subtotal from items if not provided
    const subtotal = purchaseOrder.subtotal_amount !== undefined && purchaseOrder.subtotal_amount !== null 
      ? calculateSafeAmount(purchaseOrder.subtotal_amount)
      : purchaseOrder.items?.reduce((sum, item) => {
          const itemTotal = calculateSafeAmount(item.quantity) * calculateSafeAmount(item.unit_price);
          return sum + itemTotal;
        }, 0) || 0;

    const discount = calculateSafeAmount(purchaseOrder.discount_amount);
    const vat = calculateSafeAmount(purchaseOrder.vat_amount);
    
    // Calculate total safely
    const total = purchaseOrder.total_amount !== undefined && purchaseOrder.total_amount !== null
      ? calculateSafeAmount(purchaseOrder.total_amount)
      : subtotal - discount + vat;
    
    // Determine VAT label based on stored VAT type
    let vatLabel = 'VAT';
    if (purchaseOrder.vat_type === 'percentage' && purchaseOrder.vat_value) {
      const vatValue = calculateSafeAmount(purchaseOrder.vat_value);
      vatLabel = `VAT (${vatValue}%)`;
    } else if (purchaseOrder.vat_type === 'amount') {
      vatLabel = 'VAT (Fixed Amount)';
    }

    const logoUrl = `${window.location.origin}${process.env.PUBLIC_URL || ''}/logo.svg`;

    element.innerHTML = `
      <div style="border-bottom: 2px solid #2E8B57; padding-bottom: 20px; margin-bottom: 25px;">
        <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 15px;">
          <div style="flex: 1;">
            <!-- Logo would be inserted here -->
            <img src="${logoUrl}" 
                 alt="Lite Grocer Logo" 
                 style="max-width: 100%; max-height: 100%; object-fit: contain;"
                 onerror="this.style.display='none';">
          </div>
          <div style="flex: 2; text-align: center;">
            <h1 style="font-size: 28px; font-weight: bold; margin: 0 0 5px 0; color: #2E8B57;">LITE GROCER PVT LIMITED</h1>
            <p style="font-size: 12px; margin: 2px 0; color: #666;">Premium Grocery Suppliers</p>
          </div>
          <div style="flex: 1; text-align: right;">
            <p style="font-size: 16px; font-weight: bold; margin: 0; color: #2E8B57;">PURCHASE ORDER</p>
            <p style="font-size: 12px; margin: 2px 0;">PO: ${purchaseOrder.po_number || 'N/A'}</p>
          </div>
        </div>
        
        <div style="display: flex; justify-content: space-between; font-size: 11px; color: #666;">
          <div>
            <strong>Address:</strong> No.293/22, Suramya place, gorakapala, Panadura
          </div>
          <div>
            <strong>City:</strong> Kalutara
          </div>
          <div>
            <strong>Phone:</strong> +94 71 608 2005
          </div>
        </div>
      </div>

      <div style="display: flex; justify-content: space-between; margin-bottom: 30px;">
        <div style="flex: 1; background: #f8f9fa; padding: 15px; border-radius: 8px; border-left: 4px solid #2E8B57;">
          <h3 style="margin: 0 0 10px 0; color: #2E8B57; font-size: 14px;">SUPPLIER</h3>
          <p style="margin: 5px 0; font-weight: bold;">${purchaseOrder.supplier?.name || 'N/A'}</p>
          <p style="margin: 5px 0; font-size: 12px;">${purchaseOrder.supplier?.address || 'N/A'}</p>
          ${purchaseOrder.supplier?.contact ? `<p style="margin: 5px 0; font-size: 12px;">📞 ${purchaseOrder.supplier.contact}</p>` : ''}
        </div>
        
        <div style="flex: 1; margin-left: 20px;">
          <div style="background: #f8f9fa; padding: 15px; border-radius: 8px; border-left: 4px solid #3498db;">
            <h3 style="margin: 0 0 10px 0; color: #3498db; font-size: 14px;">ORDER DETAILS</h3>
            <p style="margin: 5px 0; font-size: 12px;"><strong>PO Date:</strong> ${purchaseOrder.order_date ? new Date(purchaseOrder.order_date).toLocaleDateString('en-GB') : 'N/A'}</p>
            <p style="margin: 5px 0; font-size: 12px;"><strong>PO Number:</strong> ${purchaseOrder.po_number || 'N/A'}</p>
            <p style="margin: 5px 0; font-size: 12px;"><strong>Status:</strong> <span style="color: #2E8B57;">${purchaseOrder.status || 'N/A'}</span></p>
            <p style="margin: 5px 0; font-size: 12px;"><strong>VAT Type:</strong> ${purchaseOrder.vat_type === 'percentage' ? `${calculateSafeAmount(purchaseOrder.vat_value)}%` : 'Fixed Amount'}</p>
          </div>
        </div>
      </div>

      <table style="width: 100%; border-collapse: collapse; margin-bottom: 25px; font-size: 12px;">
        <thead>
          <tr style="background-color: #2E8B57; color: white;">
            <th style="padding: 12px; text-align: left; border: 1px solid #ddd; width: 40%;">Item Description</th>
            <th style="padding: 12px; text-align: center; border: 1px solid #ddd; width: 15%;">Quantity</th>
            <th style="padding: 12px; text-align: center; border: 1px solid #ddd; width: 15%;">Unit</th>
            <th style="padding: 12px; text-align: right; border: 1px solid #ddd; width: 15%;">Unit Price (LKR)</th>
            <th style="padding: 12px; text-align: right; border: 1px solid #ddd; width: 15%;">Amount (LKR)</th>
          </tr>
        </thead>
        <tbody>
          ${(purchaseOrder.items || []).map((item, index) => {
            const quantity = calculateSafeAmount(item.quantity, 0);
            const unitPrice = calculateSafeAmount(item.unit_price, 0);
            const itemTotal = quantity * unitPrice;
            
            return `
            <tr style="${index % 2 === 0 ? 'background-color: #f8f9fa;' : ''}">
              <td style="padding: 10px; border: 1px solid #e0e0e0;">
                <strong>${item.product?.name || 'N/A'}</strong>
                ${item.product?.description ? `<br><span style="color: #666; font-size: 11px;">${item.product.description}</span>` : ''}
              </td>
              <td style="padding: 10px; text-align: center; border: 1px solid #e0e0e0;">${quantity}</td>
              <td style="padding: 10px; text-align: center; border: 1px solid #e0e0e0;">${item.unit || 'Pcs'}</td>
              <td style="padding: 10px; text-align: right; border: 1px solid #e0e0e0;">${unitPrice.toFixed(2)}</td>
              <td style="padding: 10px; text-align: right; border: 1px solid #e0e0e0; font-weight: bold;">${itemTotal.toFixed(2)}</td>
            </tr>
          `}).join('')}
        </tbody>
      </table>

      <div style="display: flex; justify-content: flex-end; margin-bottom: 30px;">
        <div style="width: 300px;">
          <table style="width: 100%; border-collapse: collapse; font-size: 12px;">
            <tr>
              <td style="padding: 8px; text-align: right; border: 1px solid #e0e0e0;"><strong>Subtotal:</strong></td>
              <td style="padding: 8px; text-align: right; border: 1px solid #e0e0e0; width: 120px;">LKR ${subtotal.toFixed(2)}</td>
            </tr>
            ${discount > 0 ? `
            <tr>
              <td style="padding: 8px; text-align: right; border: 1px solid #e0e0e0;">Discount:</td>
              <td style="padding: 8px; text-align: right; border: 1px solid #e0e0e0;">LKR ${discount.toFixed(2)}</td>
            </tr>
            ` : ''}
            ${vat > 0 ? `
            <tr>
              <td style="padding: 8px; text-align: right; border: 1px solid #e0e0e0;">${vatLabel}:</td>
              <td style="padding: 8px; text-align: right; border: 1px solid #e0e0e0;">LKR ${vat.toFixed(2)}</td>
            </tr>
            ` : ''}
            <tr style="background-color: #2E8B57; color: white;">
              <td style="padding: 12px; text-align: right; border: 1px solid #2E8B57; font-weight: bold;">Total Amount:</td>
              <td style="padding: 12px; text-align: right; border: 1px solid #2E8B57; font-weight: bold;">LKR ${total.toFixed(2)}</td>
            </tr>
          </table>
        </div>
      </div>

      <div style="margin-top: 40px; font-size: 11px;">
        <div style="display: flex; justify-content: space-between;">
          <div style="flex: 1;">
            <div style="border-top: 1px solid #ccc; padding-top: 15px;">
              <p style="margin: 5px 0; font-weight: bold;">Delivery Instructions:</p>
              <p style="margin: 5px 0;">Please deliver to our main warehouse address</p>
              <p style="margin: 5px 0;">Delivery within 7 business days</p>
            </div>
          </div>
          <div style="flex: 1; text-align: center;">
            <div style="border-top: 1px solid #ccc; padding-top: 15px;">
              <p style="margin: 5px 0; font-weight: bold;">Supplier Acknowledgement</p>
              <p style="margin: 30px 0 5px 0;">.......................................</p>
              <p style="margin: 5px 0;">Authorized Signature</p>
            </div>
          </div>
          <div style="flex: 1; text-align: right;">
            <div style="border-top: 1px solid #ccc; padding-top: 15px;">
              <p style="margin: 5px 0; font-weight: bold;">For Lite Grocer Pvt Limited</p>
              <p style="margin: 30px 0 5px 0;">.......................................</p>
              <p style="margin: 5px 0;">Authorized Signature</p>
              <p style="margin: 5px 0; font-size: 10px;">Purchase Manager</p>
            </div>
          </div>
        </div>
      </div>

      <div style="margin-top: 30px; padding: 15px; background: #f8f9fa; border-radius: 8px; font-size: 10px; color: #666; text-align: center;">
        <p style="margin: 2px 0;">
          <strong>Lite Grocer Pvt Limited</strong> | 
          No.293/22, Suramya place, gorakapala, Panadura, Kalutara | 
          📞 +94 71 608 2005 | 
          ✉️ litegrocer@gmail.com
        </p>
        <p style="margin: 2px 0;">
          ⏰ Business Hours: 9:00 AM - 6:00 PM (Monday - Saturday) | 
          Company Registration: PVT Limited
        </p>
      </div>
    `;

    document.body.appendChild(element);

    try {
      const canvas = await html2canvas(element, {
        scale: 2,
        useCORS: true,
        logging: false,
        backgroundColor: '#ffffff'
      });

      const imgData = canvas.toDataURL('image/png');
      
      const pdf = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: 'a4'
      });

      const imgWidth = 210;
      const pageHeight = 295;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      let heightLeft = imgHeight;

      let position = 0;

      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      while (heightLeft >= 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }

      pdf.save(`LiteGrocer-PO-${purchaseOrder.po_number || 'unknown'}.pdf`);
    } catch (error) {
      console.error('Error generating PDF:', error);
      // Fallback to basic PDF
      try {
        await pdfService.generatePurchaseOrderPDF(purchaseOrder);
      } catch (fallbackError) {
        console.error('Fallback PDF generation also failed:', fallbackError);
        throw new Error('PDF generation failed');
      }
    } finally {
      document.body.removeChild(element);
    }
  }
};

export default pdfServiceAdvanced;